import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {Query} from 'app/models/query/query';
import {Event, EventId} from 'app/models/base/event';

import {UserCalendar} from 'app/models/lookups/user-calendar';
import {UserCalendarService} from 'app/services/lookups/user-calendar.service';

import {ModalDirective} from 'ng2-bootstrap';
import {forkJoin} from 'rxjs';


@Component({
  selector: 'bms-user-calendar',
  templateUrl: './user-calendar.component.html',
  styleUrls: ['./user-calendar.component.scss']
})
export class UserCalendarComponent implements OnInit {

  public danas = new Date();
  public datum = new Date();


  @Input() activeUserId: any;

  calendarItems: UserCalendar[] = null;

  @ViewChild('newCalendarItem', {static: false})
  private newCalendarItem: ModalDirective;


  constructor(private userCalendarService: UserCalendarService) {
  }

  listUserCalendarItems(): Observable<UserCalendar[]> {
    return this.userCalendarService.listUserCalendarItems(new Query());
  }

  ngOnInit() {
    this.initCalendar();
  }

  onEvent(event: Event) {

    if (event.id === EventId.DIALOG_CANCEL) {
      this.newCalendarItem.hide();
    }

    this.initCalendar();
  }


  initCalendar() {
    forkJoin(this.listUserCalendarItems()).subscribe(data => {
      this.calendarItems = data[0];
    });
  }


  createDate(date, days, months, years) {
    if (!date) {
      date = new Date();
    }
    date.setDate(date.getDate() + days);
    date.setMonth(date.getMonth() + months);
    date.setFullYear(date.getFullYear() + years);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  nextMonth() {
    this.datum = this.createDate(this.datum, 0, 1, 0);
  }

  prevMonth() {
    this.datum = this.createDate(this.datum, 0, -1, 0);
  }

  nextYear() {
    this.datum = this.createDate(this.datum, 0, 0, 1);
  }

  prevYear() {
    this.datum = this.createDate(this.datum, 0, 0, -1);
  }

  getMonthSrb() {
    const month = this.datum.getMonth();
    switch (month) {
      case 0:
        return 'Januar';
      case 1:
        return 'Februar';
      case 2:
        return 'Mart';
      case 3:
        return 'April';
      case 4:
        return 'Maj';
      case 5:
        return 'Jun';
      case 6:
        return 'Jul';
      case 7:
        return 'Avgust';
      case 8:
        return 'Septembar';
      case 9:
        return 'Oktobar';
      case 10:
        return 'Novembar';
      case 11:
        return 'Decembar';
    }
  }

  range(a, b) {
    const arr = [];
    for (let i = a; i <= b; i++) {
      arr.push(i);
    }
    return arr;
  }

  maxDayOfMonth() {
    return new Date(this.datum.getFullYear(), this.datum.getMonth() + 1, 0).getDate();
  }

  firstDayOfMonth() {
    const dan = new Date(this.datum.getFullYear(), this.datum.getMonth(), 1).getDay();
    if (dan === 0) {
      return 7;
    } else {
      return dan;
    }
  }

  clickDay(dan: { innerHTML: number; }) {
    this.datum.setDate(dan.innerHTML);
    this.newCalendarItem.show();
  }

  isActive(dan: number) {
    for (const item of this.calendarItems) {
      if (new Date(item.dateOfEvent).getDate() === dan && new Date(item.dateOfEvent).getMonth() === this.datum.getMonth() &&
        new Date(item.dateOfEvent).getFullYear() === this.datum.getFullYear()) {
        return true;
      }
    }
    return false;
  }

  pastDay(dan) {
    if (this.datum.getFullYear() > this.danas.getFullYear()) {
      return false;
    }
    if (this.datum.getMonth() > this.danas.getMonth()) {
      return false;
    }
    if (this.datum.getMonth() === this.danas.getMonth() && dan >= this.danas.getDate()) {
      return false;
    }

    return true;
  }

  haveAllFinishedTasks(dan: number) {
    for (const item of this.calendarItems) {
      if (new Date(item.dateOfEvent).getDate() === dan && new Date(item.dateOfEvent).getMonth() === this.datum.getMonth() &&
        new Date(item.dateOfEvent).getFullYear() === this.datum.getFullYear()) {
        if (item.activity === 1) {
          return false;
        }
      }
    }
    return true;
  }


}
